"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_typeahead_service_1 = require("./base-typeahead-service");
var BhtpBaseProviderTypeaheadService = (function (_super) {
    __extends(BhtpBaseProviderTypeaheadService, _super);
    function BhtpBaseProviderTypeaheadService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    BhtpBaseProviderTypeaheadService.prototype.search = function (searchValue) {
        var url = this.getFullUrl("/Provider/Search/" + encodeURIComponent(searchValue) + "/" + this.typeAsString);
        var options = this.getStandardRequestOptions();
        return this.http.get(url, options).map(function (res) {
            return res.json().sort(function (a, b) { return b.importance - a.importance; });
        }).catch(this.handleError);
    };
    ;
    return BhtpBaseProviderTypeaheadService;
}(base_typeahead_service_1.BhtpBaseTypeaheadService));
BhtpBaseProviderTypeaheadService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpBaseProviderTypeaheadService);
exports.BhtpBaseProviderTypeaheadService = BhtpBaseProviderTypeaheadService;
//# sourceMappingURL=D:/a/1/s/typeahead/src/base-provider-typeahead-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/base-provider-typeahead-service.js